import { AnyObject } from "global";
import NonAttendeeApplicationStatus from "shared/enums/NonAttendeeApplicationStatus";
import ParticipantSubRole from "shared/enums/ParticipantSubRole";
import TicketStatus from "shared/enums/TicketStatus";
import { ApiRegistrationParticipantForParticipantResponse } from "../../../shared/types/ApiRegistrationParticipantForParticipantResponse";
import RegistrationStatus from "../../../shared/enums/RegistrationStatus";

export function isBuyerAttendee(subRole: ParticipantSubRole) {
  return subRole === ParticipantSubRole.BUYER;
}

export function isBulkTicketAdmin(subRole: ParticipantSubRole) {
  return subRole === ParticipantSubRole.BULK_TICKET_ADMIN;
}

function isBulkTicketPaymentPending(nonAttendeeApplicationStatus?: NonAttendeeApplicationStatus) {
  return nonAttendeeApplicationStatus === NonAttendeeApplicationStatus.BULK_TICKET_APPLICATION_PAYMENT_PENDING;
}

function isRegistrationParticipantPaymentPending(ticketStatus: TicketStatus) {
  return [
    TicketStatus.APPLICATION_FLOW_PAYMENT_PENDING,
    TicketStatus.PAYMENT_FLOW_PAYMENT_PENDING,
    TicketStatus.TICKET_TRANSFER_ACCEPTANCE_PENDING
  ].includes(ticketStatus);
}

export function isRegPaymentPending(participantObj: ApiRegistrationParticipantForParticipantResponse) {
  return (
    isRegistrationParticipantPaymentPending(participantObj.ticketStatus) ||
    isBulkTicketPaymentPending(participantObj?.nonAttendeeApplication?.status)
  );
}

export function isTicketStatusRejected(ticketStatus: TicketStatus) {
  return [TicketStatus.APPLICATION_FLOW_REJECTED, TicketStatus.PAYMENT_FLOW_REJECTED, TicketStatus.FREEZED].includes(
    ticketStatus
  );
}

export function isRegRejected(regStatus: RegistrationStatus) {
  return [
    RegistrationStatus.REGISTRATION_CANCELED,
    RegistrationStatus.REGISTRATION_DELETED,
    RegistrationStatus.REGISTRATION_TRANSFERRED,
    RegistrationStatus.REGISTRATION_REJECTED
  ].includes(regStatus);
}

export function isTicketCompletedOrApprovalPending(ticketStatus: TicketStatus) {
  return [
    TicketStatus.TICKET_TRANSFER_APPROVAL_PENDING,
    TicketStatus.APPLICATION_FLOW_APPROVAL_PENDING,
    TicketStatus.PAYMENT_FLOW_APPROVAL_PENDING,
    TicketStatus.COMPLETED,
    TicketStatus.TICKET_ACCEPTANCE_APPROVAL_PENDING
  ].includes(ticketStatus);
}

export function isNonAttendeeCompletedOrApprovalPending(nonAttendeeApplicationStatus?: NonAttendeeApplicationStatus) {
  if (!nonAttendeeApplicationStatus) {
    return false;
  }
  return [
    NonAttendeeApplicationStatus.COMPLETED,
    NonAttendeeApplicationStatus.BULK_TICKET_APPLICATION_APPROVAL_PENDING,
    NonAttendeeApplicationStatus.ORG_ADMIN_APPLICATION_APPROVAL_PENDING
  ].includes(nonAttendeeApplicationStatus);
}

function constructObjectFrom2DArray(array: Array<Array<string>>) {
  const obj: AnyObject = {};
  for (let [k, v] of array) {
    obj[k] = v;
  }
  return obj;
}

export function getAllUtmSearchParams(searchParams: URLSearchParams): object {
  // searchParams.entries returns a 2D array, internal array has indexed [key, value] pairs
  const allSearchParams = Array.from(searchParams.entries());
  // return an object with all available utm keys
  return constructObjectFrom2DArray(
    allSearchParams?.filter(param => {
      const [key] = param;
      return key.startsWith("utm_");
    }) as any
  );
}

export function convertObjectToQueryString(utmSearchParams: AnyObject) {
  const searchParams = new URLSearchParams();
  Object.keys(utmSearchParams).forEach(key => searchParams.append(key, utmSearchParams[key]));
  return searchParams.toString();
}
